import React, { useMemo } from "react";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers";
import { DateTime, Interval } from "luxon";
import { ifStyles, mapStyles, mergeStyles } from "../libs/styles";
import { Badge, Box, CircularProgress, Icon } from "@mui/material";
import { HourglassBottom, HourglassEmpty, HourglassFull, HourglassTop } from "@mui/icons-material";
import useServiceSlots from "../hooks/useServiceSlots";

const TOTAL_SERVICE_SLOTS = 2;

// const SLOT_1;
// const SLOT_2;

export type ServiceDayProps = PickersDayProps<DateTime> & {
  scheduledIntervals?: Interval[];
  scheduledEventsIsLoading?: boolean;
}
const ServiceDay = (props: ServiceDayProps) => {
  const { day, scheduledIntervals = [], scheduledEventsIsLoading, ...rest } = props;

  const {
    slotsAvailability,
    allEmpty,
    someBusy,
    allBusy,
  } = useServiceSlots({day, scheduledIntervals});

  const availabilityIcon = () => {
    if ( rest.disabled || rest.outsideCurrentMonth) return null;
    if (scheduledEventsIsLoading) return <HourglassEmpty />;
    if (allEmpty) return <HourglassFull />;
    if (allBusy) return <HourglassEmpty />;
    if (slotsAvailability[0]) return <HourglassBottom />;
    if (slotsAvailability[1]) return <HourglassTop />;
  }

  return (
    <Box sx={styles.root} key={rest.key}>
        <PickersDay
          {...rest}
          day={day}
          sx={styles.day}
        />
      <Box
        sx={mergeStyles(
          styles.availabilityIcon,
          ifStyles(allEmpty, styles.greenIcon),
          ifStyles(someBusy, styles.orangeIcon),
          ifStyles(allBusy, styles.redIcon),
          ifStyles(scheduledEventsIsLoading, styles.greyIcon)
        )}>
        {availabilityIcon()}
      </Box>
    </Box>
  );
}

export default ServiceDay;

const styles = mapStyles({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  availabilityIcon: {
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    bottom: '2px',
    transform: 'rotate(-90deg)',
    pointerEvents: 'none',
    '& .MuiSvgIcon-root': {
      fontSize: 16,
    }
  },
  redIcon: {
    color: 'error.dark',
  },
  orangeIcon: {
    color: 'warning.main',
  },
  greenIcon: {
    color: 'success.light',
  },
  greyIcon: {
    color: "grey.400",
  },
  day: {
    fontWeight: 'bold',
    pb: '0.75em',
    fontSize: 14,
  },
});